import { useSetLifecycleFavorite, useUpdateLifecycle } from '@/queries/tanstack/database/entities';
import type { LifecycleInitiative } from '@/shared/components/lifecycles';

import { useWorkspaceResourceStateActions } from './useWorkspaceResourceStateActions';

/** One mutation boundary shared by the Lifecycle resource header and actions dropdown. */
export const useLifecycleResourceActions = (lifecycle?: LifecycleInitiative) => {
    const favoriteMutation = useSetLifecycleFavorite(lifecycle?.id);
    const updateMutation = useUpdateLifecycle(lifecycle?.id);
    const actions = useWorkspaceResourceStateActions(
        lifecycle,
        {
            setArchived: (archived) => updateMutation.mutateAsync({ archived, revision: lifecycle?.revision ?? 1 }),
            setFavorite: (favorited) => favoriteMutation.mutateAsync(favorited),
            setLocked: (locked) => updateMutation.mutateAsync({ locked, revision: lifecycle?.revision ?? 1 }),
        },
        { archived: 'Archived', favorited: 'Favorites', locked: 'Locked' },
    );

    return {
        ...actions,
        favoritePending: favoriteMutation.isPending,
        statePending: updateMutation.isPending,
    };
};
